import React from 'react';

// Material UI
import Box from '@material-ui/core/Box';

// Component
import { EnhancedTable, IEnhancedTableColumn, IEnhancedTableRow } from '../../_core/_ui/table.components';
import { Spacer } from '../../_core/_ui/structure.components';
import { PrimaryButton } from '../../_core/_ui/buttons.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { ReportFreshnessNotice } from '../report-freshness-notice.component';
import { getMessages } from '../report.messages';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { SportTerminology } from '../../../lib/types';

interface ISkillComparisonReport {
  columns: IEnhancedTableColumn[];
  reportRows: IEnhancedTableRow[],
  loading: boolean;
  fetchError: boolean;
  exportReports: ClickHandler;
  defaultOrder?: string;
}

export const SkillComparisonReport: React.FC<ISkillComparisonReport> = ({
  columns,
  reportRows,
  fetchError,
  loading,
  exportReports,
  defaultOrder = "overallRank"
}) => {
  const termLookup = useCompanySportTerminology();
  const messages = getMessages(termLookup);

  return (
    <>
      <Box mb={2} display="flex" alignItems="center">
        <ReportFreshnessNotice />
        <Spacer />
        <PrimaryButton onClick={exportReports}><IntlMsg {...messages.btnExportReport} /></PrimaryButton>
      </Box>
      <EnhancedTable
        stickyHeader
        maxHeight="800px"
        numCols={columns.length}
        rows={reportRows}
        columns={columns}
        defaultOrder={defaultOrder}
        defaultOrderDirection="asc"
        entityName="players"
        showError={fetchError}
        showLoading={loading && reportRows.length === 0}
        title={termLookup[SportTerminology.METRIC] + " Comparison"}
      />
    </>
  );
};
